// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  enforceHttps: true,
  apiRoute: 'http://127.0.0.1:43089/',
  // apiRoute: 'https://boma-api-staging.azurewebsites.net/',
  contentRoute: 'https://staging-static-boma.azureedge.net/',
  // These routes are getting called from the Shared menu component I think thats why it is confusing having them in the supplier portal too...
  supplierRoute: 'https://portal.boma.today/',
  adminRoute: 'https://admin.boma.today/',
  websiteRoute: 'https://www.boma.today/',
  apiVersion: '1.0',
  authentication: {
    issuer: 'https://auth-staging.boma.today/',
    clientId: 'staging-website',
    scopes: 'openid offline_access api',
  },
  tingg: {
    serviceCode: 'BOMDEV0600',
    failedRedirectUrl: 'https://localhost:4200/payment/failed',
    pendingRedirectUrl: 'https://localhost:4200/payment/processing',
    paymentWebhookUrl:
      'https://localhost:43089/api/v1.0/Checkout/Tingg/Response', // backend call to tell api its paid
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
